workSet